import { InjectionToken } from '@angular/core';
export var JWT_OPTIONS = new InjectionToken('JWT_OPTIONS');



//////////////////
// WEBPACK FOOTER
// ./~/@auth0/angular-jwt/src/jwtoptions.token.js
// module id = 187
// module chunks = 0